// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__eur7Q","headingWrapper":"styles_headingWrapper__YTzua","storesWrapper":"styles_storesWrapper__-iXAe","stepsWrapper":"styles_stepsWrapper__rgYEz"};